import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { getProduct } from "@/data/content";

const CartContext = createContext(null);
const STORAGE_KEY = "jinsu-cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const add = (slug, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.slug === slug);
      if (found) {
        return prev.map((i) => (i.slug === slug ? { ...i, qty: i.qty + qty } : i));
      }
      return [...prev, { slug, qty }];
    });
  };

  const setQty = (slug, qty) => {
    setItems((prev) =>
      qty <= 0 ? prev.filter((i) => i.slug !== slug) : prev.map((i) => (i.slug === slug ? { ...i, qty } : i))
    );
  };

  const remove = (slug) => setItems((prev) => prev.filter((i) => i.slug !== slug));
  const clear = () => setItems([]);

  const value = useMemo(() => {
    const detailed = items
      .map((i) => ({ ...i, product: getProduct(i.slug) }))
      .filter((i) => i.product);
    const count = detailed.reduce((s, i) => s + i.qty, 0);
    const total = detailed.reduce((s, i) => s + i.qty * i.product.price, 0);
    return { items: detailed, count, total, add, setQty, remove, clear };
  }, [items]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export function useCart() {
  return useContext(CartContext);
}

export const formatPrice = (n) =>
  n.toFixed(2).replace(".", ",").replace(",00", ",00") + " €";
